import React, { useState, useRef, useEffect } from "react";
import "./block.scss";
import { convertDatewithTime } from "../../services/Functions";

/**
 * Block component representing a user status block.
 * Displays user details in an info card on hover.
 *
 * @component
 * @memberof Components
 * @param {Object} props - Component properties
 * @param {Object} props.item - User data object
 * @param {string} props.item.isAccountExists - Indicates if the account exists ("1" for yes, "0" for no)
 * @param {boolean} props.item.isLogged_In - Indicates if the user is logged in
 * @param {string} [props.item.subDivisionCode="15171"] - Subdivision code of the user
 * @param {string} [props.item.subDivisionName="MULTAN CANTT"] - Subdivision name of the user
 * @param {string} [props.item.userName="-"] - User name
 * @param {string} [props.item.phoneNo="-"] - Phone number
 * @param {string} [props.item.loggedIn_time] - Last login time
 * @param {string} [props.item.loggedOut_time] - Last logout time
 * @param {string} props.item.companyCode - Company code
 * @param {string} props.item.companyName - Company name
 * @param {string} props.item.circleCode - Circle code
 * @param {string} props.item.circleName - Circle name
 * @param {string} props.item.divisionCode - Division code
 * @param {string} props.item.divisionName - Division name
 *
 * @returns {JSX.Element} A styled block with user information and hover details.
 */
const Block = ({ item }) => {
  const [isHovered, setIsHovered] = useState(false);
  const [positionAbove, setPositionAbove] = useState(false);
  const blockRef = useRef(null);

  /**
  * Handles mouse enter event.
  * Determines whether the info card should be positioned above or below the block.
  */
  const handleMouseEnter = () => {
    if (blockRef.current) {
      const rect = blockRef.current.getBoundingClientRect();
      const spaceBelow = window.innerHeight - rect.bottom;
      setPositionAbove(spaceBelow < 450); // If space below is less than 220px, position above
    }
    setIsHovered(true);
  };

  /**
  * Handles mouse leave event.
  * Hides the info card when the mouse leaves the block.
  */
  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  return (
    <div
      className="blockContainer"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      ref={blockRef}
    >
      <div
        className={
          item.isAccountExists == "1"
            ? item.isLogged_In
              ? "block-on"
              : "block-off"
            : "block-unknown"
        }
      >
        <p className="minuteNumber">
          {item.subDivisionCode ? item.subDivisionCode : "15171"}
        </p>
      </div>
      <div className="subDivisionName">
        {item.subDivisionName ? item.subDivisionName : "MULTAN CANTT"}
      </div>

      {isHovered && (
        <div className={`infoCard ${positionAbove ? "above" : "below"}`}>
          {/* <div className="infoCardItem">
            <strong>Account Exists:</strong> {item.isAccountExists == 1 ? "Yes" : "No"}
          </div> */}
          <div className="infoCardItem">
            <strong>User Name:</strong> {item.userName ? item.userName : "-"}
          </div>
          <div className="infoCardItem">
            <strong>Phone No:</strong> {item.phoneNo ? item.phoneNo : "-"}
          </div>
          <div className="infoCardItem">
            <strong>Last Login Time:</strong> {item.loggedIn_time ? convertDatewithTime(item.loggedIn_time) : "-"}
          </div>
          <div className="infoCardItem">
            <strong>Last Logout Time:</strong> {item.loggedOut_time ? convertDatewithTime(item.loggedOut_time) : "-"}
          </div>
          {/* <div className="infoCardItem">
            <strong>Company Code:</strong> {item.companyCode}
          </div> */}
          <div className="infoCardItem">
            <strong>Company Name:</strong> {item.companyName}
          </div>
          {/* <div className="infoCardItem">
            <strong>Circle Code:</strong> {item.circleCode}
          </div> */}
          <div className="infoCardItem">
            <strong>Circle Name:</strong> {item.circleName}
          </div>
          {/* <div className="infoCardItem">
            <strong>Division Code:</strong> {item.divisionCode}
          </div> */}
          <div className="infoCardItem">
            <strong>Division Name:</strong> {item.divisionName}
          </div>
          {/* <div className="infoCardItem">
            <strong>Sub Division Code:</strong> {item.subDivisionCode}
          </div> */}
          <div className="infoCardItem">
            <strong>Sub Division Name:</strong> {item.subDivisionName}
          </div>
          {/* <div className="infoCardItem">
            <strong>Current Status:</strong> {item.isLogged_In ? "Logged In" : "Logged Out"}
          </div> */}
        </div>
      )}
    </div>
  );
};

export default Block;
